import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
    GOOGLE_RECAPTCHA_SITE_KEY,
    name_input
} from '../../../constant/constant';
import { feedbackModel } from '../../../models/feedback';
import {
    ApiResult,
    ErrorModel,
} from '../../../models/PromiseResult';
import { url_testimonials_source } from '../../../models/feedback';
import { FeedbackService } from '../../../services/feedback.service';
import { TraceClassDecorator } from '@sentry/angular';
import { SelectItem } from 'primeng';
import { CountriesService } from 'src/app/services/countries.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';

@Component({
    selector: 'app-feedback-section',
    templateUrl: './feedback-section.component.html',
    styleUrls: [
        './../../../../assets/css/custom-egd-1.css',
        '../../../../assets/css/custom-egd.css',
        './feedback-section.component.css'
    ]
})
@TraceClassDecorator()
export class FeedbackSectionComponent implements OnInit {
    readonly name_regex: RegExp = name_input;
    data: feedbackModel = new feedbackModel();
    readonly sitekey: string = GOOGLE_RECAPTCHA_SITE_KEY;
    api_result: ApiResult = new ApiResult();
    recaptcha_Reset: boolean = false;
    source: string;
    valid_source: boolean = true;
    countries: SelectItem[] = [];
    selected_country: string = "";
    provider_id: string = "";
    slug: string = "";
    resolved(captchaResponse: string) {
        this.data.recaptcha = captchaResponse;
    }
    constructor(
        private readonly countriesService: CountriesService,
        private readonly utilitiesService: UtilitiesService,
        private readonly feedbackService: FeedbackService,
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        private readonly providerStateService: ProviderStateService
    ) { }

    async ngOnInit(): Promise<void> {
        this.slug = this.providerStateService.getProviderSlug();
        this.api_result = new ApiResult();
        this.provider_id = this.providerStateService.getProviderId();
        this.route.params.subscribe((params) => {
            this.source = params.source;
            if (url_testimonials_source[this.source] == null) {
                this.api_result.PromiseResult.success = false;
                this.api_result.PromiseResult.error = new ErrorModel();
                this.api_result.PromiseResult.error.message = 'Invalid URL';
                this.valid_source = false;
            }
        });
        this.recaptchaReset();
        await this.getCountries();
    }

    async feedbackSubmit(): Promise<void> {
        this.api_result == new ApiResult();
        this.data.country_id = Number(this.selected_country);
        this.recaptchaReset();
        await this.feedbackService
            .sendCovidFeedback(this.data, this.source)
            .toPromise()
            .then((result) => {
                this.api_result.PromiseResult = result;
                if (this.api_result.PromiseResult.success) {
                    this.data = new feedbackModel();
                }
                this.api_result.Posting = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.api_result.ServerError = error.error;
                this.api_result.PromiseResult.success = false;
                this.api_result.Posting = false;
            });
    }

    async getCountries(): Promise<void> {
        await this.countriesService
            .getCountries(this.provider_id)
            .toPromise()
            .then((countries) => {
                countries.forEach((ele) => {
                    ele["final_value"] = Number(ele.id);
                });
                this.countries = this.utilitiesService.getSelectItemList(countries, "country_name", "final_value");
            }).catch((err) => {
                console.error(err);
            });
    }

    recaptchaReset() {
        this.recaptcha_Reset = false;
        setTimeout(() => {
            this.recaptcha_Reset = true;
        }, 1000);
    }

    gotoHome() {
        this.router.navigate(['/' + this.slug + '/']);
    }
}
